module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('h2', [_vm._v("Wat vond je van deze opdracht?")]), _vm._l((_vm.questions), function(question) {
    return _c('div', {
      staticClass: "assignment-feedback",
      class: question.name
    }, _vm._l((question.options), function(option) {
      return _c('div', {
        staticClass: "input-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (question.chosen),
          expression: "question.chosen"
        }],
        staticClass: "feedback-radio",
        attrs: {
          "type": "radio",
          "id": option.tag
        },
        domProps: {
          "value": option.value,
          "checked": _vm._q(question.chosen, option.value)
        },
        on: {
          "__c": function($event) {
            question.chosen = option.value
          }
        }
      }), _c('label', {
        attrs: {
          "for": option.tag
        }
      }, [_c('span', {
        staticClass: "feedback-icon",
        class: _vm.iconClass(option, question)
      }), _c('br'), _vm._v("\n                " + _vm._s(option.text) + "\n            ")])])
    }))
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticClass: "assignment-feedback",
    attrs: {
      "placeholder": "Op- of aanmerkingen over deze opdracht"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d393693","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/AssignmentFeedbackPartial.vue
// module id = N+K9
// module chunks = 1